import React from "react";
import "./ReadMore.css";
import Nav from "react-bootstrap/Nav";
function ReadMore(props) {
  return (
    <>
      <a  className="readMore">
        {props.name} More
      </a>
    </>
  );
}

export default ReadMore;
